import type { CityConfig } from "@/pages/city-template/types";

export const topekaConfig: CityConfig = {
  city: "Topeka",
  state: "Kansas",
  stateAbbr: "KS",
  slug: "topeka",
  route: "/topeka",
  title: "Emergency Passport Topeka, KS — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Topeka, KS — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Topeka and Shawnee County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Topeka, Kansas",
  heroSubtitle: "Passport expired before your trip? Flying out of MCI in days? Fast Passport Center helps Topeka travelers get their passports fast — as fast as 24 hours. A+ BBB rated. No office visit required for most services.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Topeka%20Kansas%20State%20Capitol%20building%20with%20iconic%20copper%20dome%20against%20dramatic%20sky%2C%20downtown%20Topeka%20with%20historic%20government%20buildings%20and%20wide%20boulevards%2C%20Kansas%20River%20flowing%20nearby%2C%20late%20afternoon%20golden%20light%20casting%20warm%20shadows%2C%20Midwestern%20capital%20city%20landscape%2C%20red%20brick%20and%20limestone%20architecture&width=1800&height=700&seq=topeka-hero-01&orientation=landscape",
  heroImageAlt: "Topeka Kansas State Capitol building with copper dome and downtown landscape",
  geoPosition: "39.0473;-95.6752",
  geoPlacename: "Topeka, Kansas",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Approximately 540 miles west — nearest regional passport agency for northeast Kansas travelers",
  },
  nearbyCitiesZips: [
    { name: "Topeka", zips: "66601–66699" },
    { name: "Lawrence", zips: "66044–66049" },
    { name: "Manhattan", zips: "66502–66506" },
    { name: "Silver Lake", zips: "66539" },
    { name: "Rossville", zips: "66533" },
    { name: "Auburn", zips: "66402" },
    { name: "Carbondale", zips: "66414" },
    { name: "Tecumseh", zips: "66542" },
    { name: "Berryton", zips: "66409" },
    { name: "Meriden", zips: "66512" },
    { name: "Hoyt", zips: "66440" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from home or work in Topeka in minutes." },
    { icon: "ri-truck-line", title: "Ship Overnight from Shawnee County", desc: "FedEx and UPS locations throughout Topeka offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and delays." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport center — no public appointment hunting needed." },
  ],
  testimonials: [
    {
      name: "Robert H.",
      location: "Topeka, KS",
      rating: 5,
      text: "State government employee heading to a conference in Toronto — realized my passport expired 2 weeks before departure. Fast Passport Center got it renewed in 6 days. Shipped from the FedEx on Wanamaker. Couldn't believe how smooth it was.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia S.",
      location: "Topeka, KS",
      rating: 5,
      text: "Our church mission trip to Guatemala required passports for everyone. Fast Passport Center helped three of us get new and renewed passports within 10 days. The checklist they provided was thorough and easy to follow.",
      service: "New Passport",
    },
    {
      name: "Kevin M.",
      location: "Silver Lake, KS",
      rating: 5,
      text: "Family trip to Ireland and my wife's passport was expired. Fast Passport Center handled the renewal from our home near Topeka. Passport arrived in 7 days. We made our flight from MCI with time to spare.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "topeka-main-post",
      name: "Topeka Main Post Office",
      type: "USPS Passport Acceptance",
      address: "424 S Kansas Ave",
      city: "Topeka",
      state: "KS",
      zip: "66603",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Downtown Topeka",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance location in Topeka. Appointment required — book online well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "shawnee-county-clerk",
      name: "Shawnee County Clerk's Office",
      type: "County Passport Acceptance",
      address: "200 SE 7th St, Room 107",
      city: "Topeka",
      state: "KS",
      zip: "66603",
      phone: "785-251-5300",
      hours: "Mon–Fri 8am–4:30pm (by appointment)",
      distance: "Downtown Topeka — Shawnee County Courthouse",
      website: "https://www.snco.us/clerk/",
      websiteLabel: "Shawnee County Clerk",
      notes: "County clerk passport acceptance. Appointment recommended. May have shorter wait times than USPS.",
      icon: "ri-government-line",
    },
    {
      id: "topeka-north-post",
      name: "Topeka North Post Office",
      type: "USPS Passport Acceptance",
      address: "2201 NW Clay St",
      city: "Topeka",
      state: "KS",
      zip: "66608",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "North Topeka",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative location for northern Topeka residents.",
      icon: "ri-mail-line",
    },
    {
      id: "lawrence-post",
      name: "Lawrence Post Office",
      type: "USPS Passport Acceptance",
      address: "645 Vermont St",
      city: "Lawrence",
      state: "KS",
      zip: "66044",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Lawrence — about 27 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Nearby option for eastern Shawnee County residents near Lawrence.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Topeka before international travel?",
      a: "Yes. Through Fast Passport Center, Topeka travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours.",
    },
    {
      q: "How fast can I renew my passport in Topeka?",
      a: "Fast passport renewal in Topeka is available through Fast Passport Center in as little as 3 business days. No office visit required for most renewals.",
    },
    {
      q: "Does Topeka have a passport agency?",
      a: "Topeka, Kansas does not have a regional passport agency. The closest is the Denver Passport Agency in Hot Springs. Fast Passport Center is the faster solution — no road trip required.",
    },
    {
      q: "Can I expedite a child passport in Topeka?",
      a: "Yes. Child passport expediting in Topeka is possible through Fast Passport Center. Minors 15 and under require an in-person acceptance step with parental consent.",
    },
    {
      q: "How long does a standard passport take in Topeka?",
      a: "Standard post office processing in Topeka runs 6–13 weeks. Fast Passport Center offers Topeka travelers processing as fast as 24 hours.",
    },
    {
      q: "What airports do Topeka passport holders typically fly from?",
      a: "Kansas City International Airport (MCI) is the primary international airport for Topeka travelers, about 70 miles east. Fast Passport Center can help you meet your deadline.",
    },
    {
      q: "Can I get a passport renewal near me in Topeka without visiting an office?",
      a: "Yes. Most Topeka adults renewing a passport can do so entirely by mail. Start your order online and ship from any FedEx or UPS in Topeka.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Topeka", address: "2901 SW Wanamaker Rd, Topeka, KS 66614", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS — Topeka", address: "2121 SW Fairlawn Rd, Topeka, KS 66614", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Topeka", address: "2111 SW Wanamaker Rd, Topeka, KS 66614", hours: "Mon–Fri 7 AM – 10 PM" },
    { name: "Walgreens — Lawrence", address: "2320 Iowa St, Lawrence, KS 66046", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Topeka Driver License Office",
      address: "300 SW 29th St, Topeka, KS 66611",
      hours: "Mon–Fri 7 AM – 5:45 PM",
      note: "Shawnee County DMV office. Driver licenses, REAL ID, ID cards.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "Primary international airport — 70 miles east",
      address: "1 International Sq, Kansas City, MO 64153",
      note: "MCI is the closest major airport for Topeka travelers with direct international flights.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport Website",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line", title: "Emergency Passport",
      description: "Flying from MCI in 24–72 hours? Our emergency courier service is designed for urgent travel from Topeka.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line", title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Topeka and Shawnee County travelers renew fast.",
      bullets: ["Eligible for expedited processing", "Ship from any FedEx or UPS in Topeka", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line", title: "Lost Passport Replacement",
      description: "Lost your passport? We guide Topeka travelers through Form DS-64 and the replacement process.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line", title: "Child Passport",
      description: "Child passport expedited service for Topeka families.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line", title: "New Passport",
      description: "First-time passport application assistance for Topeka residents.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line", title: "Passport Courier Service",
      description: "Registered U.S. Department of State courier — we submit through reserved agency channels.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line", title: "Name Change & Other Services",
      description: "Passport name changes, damaged passport replacement, second passports for frequent travelers.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Topeka, Kansas travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for Topeka, KS residents." },
    { name: "Child Passport", description: "Expedited child passport services for Topeka families with minors under 16." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Topeka travelers often assume 6–8 weeks is safe — it's not. Apply as soon as you book your trip." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores often get rejected. We provide exact specs." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application gets sent back." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS processing out of Topeka runs 6–13 weeks. Use our courier service for trips under 10 weeks." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Across Documents", description: "Your passport name must match your airline ticket exactly." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your travel date." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send you exactly what you need." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Topeka", description: "Drop off at any FedEx or UPS in Topeka." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through reserved passport agency slots." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed and shipped back to you." },
  ],
  processingOptions: [
    {
      speed: "2–9", unit: "Business Days", label: "Fast Passport Center",
      tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Document review included", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5", unit: "Weeks", label: "Fast Passport Center",
      tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Document review included"],
      highlight: false, smartSaver: true,
    },
    {
      speed: "1–2", unit: "Months", label: "Self-Service (Post Office)",
      tag: "Slowest", tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access", "In-person clerk appointment required", "No document review", "Not suitable if travel is within 10 weeks"],
      highlight: false, muted: true,
    },
    {
      speed: "24", unit: "Hours*", label: "Regional Agency Processing",
      tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required", "Life-or-death emergencies only"],
      highlight: false, emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots at Denver Passport Agency", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Hot Springs, AR (5.5 hours)", fpc: "Ship documents overnight from Topeka" },
    { feature: "Processing Speed", agency: "Urgent travel only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
    { feature: "Turnaround Predictability", agency: "Depends on appointment availability — no guarantee", fpc: "Guaranteed processing within selected timeframe" },
    { feature: "Customer Support", agency: "Government clerk — limited availability", fpc: "Dedicated agent assigned to your case with daily updates" },
    { feature: "Travel Required", agency: "Yes — must travel to Denver in person", fpc: "No — ship documents from home or office in Topeka" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Lawrence", route: "/lawrence" },
    { name: "Fast passport renewal in Manhattan", route: "/manhattan" },
    { name: "Fast passport renewal for Shawnee County", route: "/kansas" },
  ],
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from any FedEx or UPS location in Topeka.",
  fpcOfficeDistance: "Serving Topeka and all of Shawnee County remotely",
  serviceAreaIntro: "Whether you are in Topeka, Silver Lake, Rossville, or anywhere in Shawnee County, Fast Passport Center makes expedited passport processing simple.",
  nearbyCitiesIntro: "We serve all Topeka and Shawnee County zip codes. Ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Topeka as simple as possible.",
  mistakesIntro: "These mistakes cause the most delays for Topeka travelers. We review your documents before submission.",
  testimonialsIntro: "Real reviews from Topeka and Shawnee County travelers who trusted Fast Passport Center.",
  faqIntro: "The most common questions Topeka and Shawnee County travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/kansas",
  statePageName: "Kansas",
};